const KEY = 'ocn.mcp.pending-authorization';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const PATH = '/mcp/authorize';
const MAX_SEARCH = 2048;

/** Same-origin path back to this exact authorize page. The path is fixed and
 * authorization_request_id is always the given id, so a saved query string can only
 * carry the page's other params, never change where the browser goes. */
export function mcpAuthorizationReturnPath(requestId: string, search = ''): string {
  const params = new URLSearchParams(search.length <= MAX_SEARCH ? search : '');
  params.set('authorization_request_id', requestId);
  return `${PATH}?${params.toString()}`;
}

/** Persist only an opaque, expiring handle (plus the page's own query string) across
 * email/GitHub browser redirects. */
export function rememberMcpAuthorization(requestId: string, now = Date.now(), search = ''): void {
  if (!UUID.test(requestId)) return;
  const query = search.length <= MAX_SEARCH ? search.replace(/^\?/, '') : '';
  try { localStorage.setItem(KEY, JSON.stringify({ id: requestId, expires: now + 600_000, search: query })); } catch { /* Same-tab sign-in still works. */ }
}
export function consumeMcpAuthorizationReturn(now = Date.now()): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    if (!raw) return null;
    const value: unknown = JSON.parse(raw);
    if (!value || typeof value !== 'object') return null;
    const row = value as Record<string, unknown>;
    if (typeof row.id !== 'string' || !UUID.test(row.id) || typeof row.expires !== 'number'
      || row.expires <= now || row.expires > now + 600_000) return null;
    return mcpAuthorizationReturnPath(row.id, typeof row.search === 'string' ? row.search : '');
  } catch { return null; }
}
export function clearMcpAuthorization(): void {
  try { localStorage.removeItem(KEY); } catch { /* No pending handle available. */ }
}
